import {
  MicrosoftWordLogoIcon,
  FilePdfIcon,
  VideoIcon,
  SpeakerHighIcon,
  ImageIcon,
  TableIcon,
  PackageIcon,
  EnvelopeSimpleIcon
} from "@phosphor-icons/react";

export const fileTypeIcons = {
  'MS Office': MicrosoftWordLogoIcon,
  'PDF': FilePdfIcon,
  'Video': VideoIcon,
  'Audio': SpeakerHighIcon,
  'Image': ImageIcon,
  'Spreadsheet': TableIcon,
  'Email': EnvelopeSimpleIcon,
  'Other': PackageIcon,
} as const;
